import { render } from "./DeclarationList.vue?vue&type=template&id=e1aa8a98"
import script from "./DeclarationList.vue?vue&type=script&lang=js"
export * from "./DeclarationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__